import React, { useEffect, useState, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";

import { Button, Container, Grid } from "@material-ui/core";

import { Link } from "react-router-dom";
// import { useSpring, useChain, animated } from "react-spring";
// import { useSubMenuPostionDispatch } from "../../../../../contexts/MenuContext";
import ArchiveYear from "./ArchiveYear";
import { useQuery } from "@apollo/client";
import { GET_ARCHIVE_MENU } from "../../../../../quries/archiveMenu";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: "relative",
    },
    popoverPaper: {
      width: "100%",
      // height: "100%",
      left: `0 !important`,
      top: `72px !important`,
      maxHeight: "unset",
      maxWidth: "unset",
      borderRadius: 0,
    },
    btnStyle: {
      paddingLeft: 16,
      paddingRight: 16,
      paddingTop: 8,
      paddingBottom: 8,

      fontWeight: 700,
      fontSize: 14,
      fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
      "&:hover": {
        background: "rgba(0,0,0,.05)",
      },
      "&::before": {
        position: "absolute",
        content: '" "',
        top: "0%",
        right: 0,
        height: "100%",
        width: 1,
        background: "rgba(34,36,38,.1)",
      },
    },

    items: {
      willChange: "auto",
      position: "relative",
      "&:hover": {
        // background: "rgba(0,0,0,.05)",
        "& $items_hidden": {
          maxHeight: "100%",
          transition: "max-height 0.25s ease-in",
          borderBottom: "1px solid rgb(188, 36, 60)",
          //   display: "block",
        },
      },

      // },
    },
    item: {
      paddingLeft: 16,
      paddingRight: 16,
      paddingTop: 8,
      paddingBottom: 8,
      willChange: "auto",
      fontWeight: 700,
      fontSize: 16,
      fontFamily: "Noto Sans KR",
      // fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",

      "&:hover": {
        background: "rgba(0,0,0,.05)",
      },
      // "&::before": {
      //   position: "absolute",
      //   content: '" "',
      //   top: "0%",
      //   right: 0,
      //   height: "100%",
      //   width: 1,
      //   background: "rgba(34,36,38,.1)",
      // },
    },

    items_hidden: {
      // visibility: "hidden",
      overflow: "hidden",
      transition: "max-height 0.15s ease-out",
      maxHeight: 0,
      position: "fixed",
      //   width: "100%",
      //   display: "none",
      left: 0,
      top: 65,
      // display: "block",
      marginTop: 7,
      listStyle: "none",
      zIndex: 1,
      color: "black",
      //   borderBottom: " 3px solid #f2f2f2",
      borderBottom: "0px solid rgb(188, 36, 60)",
      //   background: "#d5d5d5"
      backgroundColor: "white",
    },
  })
);

interface ArchiveMenuProps {
  menuName: any;
  link: any;
}

function ArchiveMenu({ menuName, link }: ArchiveMenuProps) {
  const classes = useStyles();

  const companyObj = useRef(null);

  const parent = useRef(null);

  const [on, toggle] = useState(false);

  // const [{ color }, set] = useSpring(() => ({
  //   // color: "rgb(250, 150, 50)",
  //   color: "white",
  // }));

  const [state, setState] = useState<any>(null);
  // useEffect(() => {
  //   if (scrollValue) {
  //     set({
  //       color: "black",
  //     });
  //   } else {
  //     set({
  //       // color: "rgb(250, 150, 50)",
  //       color: "white",
  //     });
  //   }
  //   return () => {};
  // }, [scrollValue]);

  // useEffect(() => {
  //   if (judege) {
  //     set({
  //       color: "black",
  //     });
  //   } else if (scrollValue && judege == false) {
  //     set({
  //       color: "black",
  //     });
  //   } else {
  //     set({
  //       // color: "rgb(250, 150, 50)",
  //       color: "white",
  //     });
  //   }
  //   return () => {};
  // }, [judege, scrollValue]);

  const { data, loading, error } = useQuery(GET_ARCHIVE_MENU);
  useEffect(() => {
    if (data && data.archiveYears) {
      setState(data.archiveYears);
    }
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.archiveYears) {
    console.log(error);
  }

  return (
    <Grid
      style={{ padding: 16, zIndex: 0 }}
      id={"parent"}
      ref={parent}
      className={classes.items}
      // onMouseEnter={() => {
      //   toggle(true);
      // }}
      // onMouseLeave={() => {
      //   toggle(false);
      // }}
    >
      <Link to={`${link}`}>
        <Button type="button" className={classes.item} ref={companyObj}>
          <span
            // style={{
            //   color: color.interpolate((color) => `${color}`),
            // }}
            style={{ color: "#bc243c" }}
          >
            {menuName}
          </span>
        </Button>
      </Link>
      <Container
        maxWidth={false}
        className={classes.items_hidden}
        component={"div"}
      >
        <Container maxWidth={"lg"}>
          <Grid xs={12} item container justify={"center"} component={"div"}>
            {state ? (
              state.map((year: any, index: any) => {
                return (
                  <ArchiveYear
                    key={`archive-menu-${year.yearTitle}-${index}`}
                    yearTitle={year.yearTitle}
                    program={year.archive_categroys}
                  />
                );
              })
            ) : (
              <div></div>
            )}
          </Grid>
        </Container>
      </Container>
    </Grid>
  );
}

export default ArchiveMenu;
